import React from 'react';
import {
  RouteWrapper,
  LinesWrapper,
  RouteTimeWrapper,
} from '../styled';
import { LimitedText } from 'components/widget/common/styled';
import WalkIcon from 'assets/svg/transportation/walk.svg';
import { Lines } from './Lines';
import { ShowAt } from 'consts/breakpoints';
import { useLocale } from 'locale';
import { Text } from 'ds/components/typography';
import { TransportationSectionType } from 'store/state/insightsContext';
import CitiBikeIcon from 'assets/svg/citi-bike-logo-p.svg';
import { stationColorToColor } from 'store/state/selectors/insights/transportation/utils';
import { TransportationAccordionRoute } from 'store/state/selectors/insights/transportation';

export interface RouteProps {
  route: TransportationAccordionRoute;
  sectionId: TransportationSectionType;
  setHoveredStation: (name: string) => void;
}

const getLongRouteLine = (longRouteName: string) => [
  {
    color: stationColorToColor.default,
    label: longRouteName,
  },
];

export const Route: React.FunctionComponent<RouteProps> = ({ route, sectionId, setHoveredStation }) => {
  const { t } = useLocale();
  const isBike = sectionId === TransportationSectionType.Bike;

  return (
    <RouteWrapper
      data-auto={route.description.replace(' ', '-')}
      key={route.description}
      onMouseEnter={() => setHoveredStation(route.description)}
      onMouseLeave={() => setHoveredStation(null)}
    >
      <ShowAt to={2}>
        <RouteTimeWrapper>
          <WalkIcon />
          <Text>{t('transportationAccordion.walkTimeToPointShort', {
            time: route.time,
          })}</Text>
        </RouteTimeWrapper>
        <LimitedText>
          <Text>
            {route.description}
          </Text>
        </LimitedText>
      </ShowAt>
      <ShowAt from={3}>
        <RouteTimeWrapper>
          <Text>{t('transportationAccordion.walkTimeToPoint', {
            time: route.time,
          })}</Text>
        </RouteTimeWrapper>
        <LimitedText maxWidth={200}>
          <Text>
            {route.description}
          </Text>
        </LimitedText>
      </ShowAt>
      <LinesWrapper>
        {isBike ? <CitiBikeIcon height={16} /> : null}
        {route.lines && route.lines.length
          ? <Lines accessible={route.accessible} lines={route.lines} sectionId={sectionId} />
          : null}
        {route.routeLongName
          ? (
            <Lines
              accessible={route.accessible}
              lines={getLongRouteLine(route.routeLongName)}
              sectionId={TransportationSectionType.Bus}
            />
          ) : null}
      </LinesWrapper>
    </RouteWrapper>
  );
};
